import React, { useEffect, useState } from "react";
import "./MakroohWarning.css";

interface MakroohWarningProps {
  reason: string | null;
  customizedNames: {
    sunrise?: string;
    noon?: string;
    sunset?: string;
  };
  // Azure Best Practice: Add duration parameter with type safety
  duration?: {
    sunrise?: number;
    zawwal?: number;
    sunset?: number;
  };
  secondsLeft?: number; // Seconds remaining in makrooh period
  showTimer?: boolean; // Show/hide countdown timer line
  countdownLabel?: string; // Case-sensitive label shown next to timer
}

const MakroohWarning: React.FC<MakroohWarningProps> = ({
  reason,
  customizedNames,
  duration = {}, // Default to empty object if not provided
  secondsLeft = 0,
  showTimer = true,
  countdownLabel = "Time Remaining:",
}) => {
  const [localSeconds, setLocalSeconds] = useState(secondsLeft);

  // Update local seconds when prop changes
  useEffect(() => {
    setLocalSeconds(secondsLeft);
  }, [secondsLeft]);

  // Countdown timer
  useEffect(() => {
    if (localSeconds <= 0) return;
    const timer = setInterval(() => {
      setLocalSeconds((s) => (s > 0 ? s - 1 : 0));
    }, 1000);
    return () => clearInterval(timer);
  }, [localSeconds]);

  if (!reason) return null;

  // Format seconds as mm:ss
  const formatTime = (secs: number) => {
    const m = Math.floor(secs / 60);
    const s = secs % 60;
    return `${m}:${s.toString().padStart(2, "0")}`;
  };

  let message = "It is makrooh to pray any salah at this time";

  if (reason === "sunrise") {
    // Get the duration for sunrise, default to 10 if not specified
    const sunriseDuration = duration.sunrise || 10;
    message = `It is makrooh to pray any salah for up to ${sunriseDuration} mins after ${
      customizedNames.sunrise || "Sunrise"
    }`;
  } else if (reason === "zawwal") {
    // Get the duration for zawwal (noon), default to 10 if not specified
    const zawwalDuration = duration.zawwal || 10;
    message = `It is makrooh to pray any salah for up to ${zawwalDuration} mins around ${
      customizedNames.noon || "Noon"
    } time`;
  } else if (reason === "sunset") {
    // Get the duration for sunset, default to 10 if not specified
    const sunsetDuration = duration.sunset || 10;
    message = `It is makrooh to pray any salah for up to ${sunsetDuration} mins before ${
      customizedNames.sunset || "Sunset"
    }`;
  }

  return (
    <div className="makrooh-warning">
      <div className="makrooh-icon">⚠️</div>
      <div className="makrooh-message">{message}</div>
      {showTimer && localSeconds > 0 && (
        <div className="makrooh-timer">
          {countdownLabel ? <strong>{countdownLabel}</strong> : null}
          {countdownLabel ? " " : ""}
          {formatTime(localSeconds)}
        </div>
      )}
    </div>
  );
};

export default MakroohWarning;
